import { Box, FormControl, FormLabel, Input, Button, Stack } from '@chakra-ui/react'

export function SearchForm({ numNota, setNumNota, isLoading, handleSearch }) {
  return (
    <Box mb={8} p={6} shadow="md" borderWidth="1px" borderRadius="lg" bg="#3a4a53" color="white">
      <Stack spacing={4}>
        <FormControl isRequired>
          <FormLabel>Número da Nota</FormLabel>
          <Input
            placeholder="Digite o número da nota"
            value={numNota}
            onChange={(e) => setNumNota(e.target.value)}
            type="number"
            size="lg"
            bg="#4a5a64"
            focusBorderColor="#37F091"
          />
        </FormControl>

        <Button
          bgColor="#37F091"
          color="#313E44"
          _hover={{ bg: '#2cdf7f' }}
          isLoading={isLoading}
          onClick={handleSearch}
          size="lg"
          isDisabled={!numNota}
          fontWeight="bold"
        >
          Buscar Pedido
        </Button>
      </Stack>
    </Box>
  )
}
